// Turn arbitrary video links into something embeddable.
// YouTube / Vimeo → iframe embed URL; anything else → play in <video>.
export function parseVideoLink(url) {
  if (!url) return { kind: "direct", src: url };
  try {
    const u = new URL(url);
    const host = u.hostname.replace(/^www\./, "");
    if (host === "youtube.com" || host === "m.youtube.com") {
      const id = u.searchParams.get("v") || u.pathname.match(/\/(shorts|embed)\/([\w-]{6,})/)?.[2];
      if (id) return { kind: "iframe", src: `https://www.youtube.com/embed/${id}` };
    }
    if (host === "youtu.be") {
      const id = u.pathname.slice(1).split("/")[0];
      if (id) return { kind: "iframe", src: `https://www.youtube.com/embed/${id}` };
    }
    if (host === "vimeo.com") {
      const id = u.pathname.split("/").filter(Boolean)[0];
      if (id && /^\d+$/.test(id)) return { kind: "iframe", src: `https://player.vimeo.com/video/${id}` };
    }
    if (host === "player.vimeo.com" || u.pathname.includes("/embed/")) {
      return { kind: "iframe", src: url };
    }
  } catch {
    // fall through to direct
  }
  return { kind: "direct", src: url };
}
